import { useTranslation } from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import React, { FC } from 'react';
import CancelIcon from '@mui/icons-material/Cancel';
import { Box, Button, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { PortfolioUpload } from '../../types';
import { theme } from '../../../../../theme';

type UploadStatus = {
  item: PortfolioUpload;
  onDownloadDetails: (item: PortfolioUpload) => void;
  onDownloadErrorReport: (item: PortfolioUpload) => void;
};

const useStyles = makeStyles(() => ({
  iconTextWrapper: {
    display: 'flex',
    gridGap: theme.spacing(1),
    alignItems: 'center',
  },
  uploadedIconColor: {
    color: theme.palette.custom.green,
  },
  errorIconColor: {
    color: theme.palette.custom.error,
  },
}));

export const UploadStatus: FC<UploadStatus> = ({
  item,
  onDownloadDetails,
  onDownloadErrorReport,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  if (item.uploadStatus === 'ERROR') {
    return (
      <Button
        disabled={!item.errorsLink}
        className={classes.iconTextWrapper}
        onClick={() => onDownloadErrorReport(item)}
      >
        <ErrorIcon fontSize="small" className={classes.errorIconColor} />
        <Typography>{t('PORTFOLIO_UPLOAD.STATUS_ERROR')}</Typography>
      </Button>
    );
  }
  if (item.uploadStatus === 'FAILED') {
    return (
      <Button
        disabled={!item.errorsLink}
        className={classes.iconTextWrapper}
        onClick={() => onDownloadErrorReport(item)}
      >
        <CancelIcon fontSize="small" className={classes.errorIconColor} />
        <Typography>{t('PORTFOLIO_UPLOAD.STATUS_FAILED')}</Typography>
      </Button>
    );
  }
  if (item.uploadStatus === 'FINISHED') {
    return (
      <Button className={classes.iconTextWrapper}>
        <CheckCircleIcon fontSize="small" className={classes.uploadedIconColor} />
        <Typography onClick={() => onDownloadDetails(item)}>
          {t('PORTFOLIO_UPLOAD.STATUS_FINISHED')}
        </Typography>
      </Button>
    );
  }
  return <Typography>{t('PORTFOLIO_UPLOAD.STATUS_UPLOADING')}</Typography>;
};
